import Vue from 'vue'

export const store = Vue.observable({
  activeForgotPasswordModal: false
})
export const mutation = {
  setActiveForgotPasswordModal: (activeModal) => {
    store.activeForgotPasswordModal = activeModal
  }
}